import { render } from "./noData.vue?vue&type=template&id=50477a19&scoped=true"
import script from "./noData.vue?vue&type=script&lang=js"
export * from "./noData.vue?vue&type=script&lang=js"

import "./noData.vue?vue&type=style&index=0&id=50477a19&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50477a19"],['__file',"src/views/data/components/noData.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "50477a19"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('50477a19', __exports__)) {
    console.log('reload')
    api.reload('50477a19', __exports__)
  }
  
  module.hot.accept("./noData.vue?vue&type=template&id=50477a19&scoped=true", () => {
    console.log('re-render')
    api.rerender('50477a19', render)
  })

}


export default __exports__